import kebabCase from 'lodash/kebabCase'

import { Tooltip } from '../Tooltip'
import { ButtonGroupProps } from './_types'
import * as S from './ButtonGroup.styles'
import { ControlButton } from './ControllButton'

export function ButtonGroup<T>({
  title,
  options,
  name,
  multipleSelect = false,
  onClick,
  currentSelection,
  dataCy,
  rectangular = false,
  className,
  theme,
  fullWidth = false,
}: ButtonGroupProps<T>) {
  const _name = name || kebabCase(title)

  return (
    <S.Root className={className} $theme={theme}>
      {title && <S.GroupTitle>{title}</S.GroupTitle>}
      <S.GroupContainer data-cy={dataCy} $rectangular={rectangular} $fullWidth={fullWidth}>
        {options.map((option, idx) => (
          <Tooltip
            key={`${option.title}-${option.id}-${idx}`}
            content={option.tooltipText}
            placement="bottom"
          >
            <S.ControlButtonWrapper>
              <ControlButton
                key={option.id}
                id={option.id}
                value={option.value}
                title={option.title}
                disabled={option.disabled}
                name={_name}
                defaultChecked={option.defaultChecked}
                checked={option.checked || option.value === currentSelection}
                className={option.className}
                multipleSelect={multipleSelect}
                onClick={() => onClick(option.value)}
                dataCy={option.dataCy}
                rectangular={rectangular}
              >
                {option.children}
              </ControlButton>
            </S.ControlButtonWrapper>
          </Tooltip>
        ))}
      </S.GroupContainer>
    </S.Root>
  )
}
